import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import { getPosApiUrl, getAccessToken } from '../../utils/state';
import { replaceAlerts } from '../../components/alert-bar/AlertBar.state';
import { openCashDrawer } from '../../utils/api/client';
import { closeoutErrorEpic } from '../../pages/closeout/Closeout.epic';
import { closeoutAlertBarAction } from '../../pages/closeout/Closeout.state';
import { cashDropAlertBarAction } from '../../pages/cash-drop/CashDrop.state';
import { OPEN_CASH_DRAWER } from '../peripheralDevices';
import { cashDropErrorEpic } from '../../pages/cash-drop/CashDrop.epics';
import { EMPTY_ACTION } from '..';

const peripheralAlertBarAction = (currentPathname) => {
  if (currentPathname.includes('closeout')) {
    return Rx.of(
      closeoutAlertBarAction(
        replaceAlerts({
          heading: 'Cash Drawer Opened',
          variant: 'info',
        }),
      ),
    );
  } else if (currentPathname.includes('cashdrop')) {
    return Rx.of(
      cashDropAlertBarAction(
        replaceAlerts({
          heading: 'Cash Drawer Opened',
          variant: 'info',
        }),
      ),
    );
  } else {
    return Rx.of(EMPTY_ACTION);
  }
};

const cashDrawerOpenError = (currentPathname, err) => {
  if (currentPathname.includes('closeout')) {
    return closeoutErrorEpic({
      errorMessage: err.message,
    });
  } else if (currentPathname.includes('cashdrop')) {
    return cashDropErrorEpic({
      errorMessage: err.message,
    });
  } else {
    return Rx.of(EMPTY_ACTION);
  }
};

const openCashDrawerParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});
export const openCashDrawerEpic = (action$, state$) =>
  action$.ofType(OPEN_CASH_DRAWER).pipe(
    RxOp.flatMap((action) =>
      Rx.from(openCashDrawer(openCashDrawerParams(state$.value))).pipe(
        RxOp.flatMap(() => {
          return peripheralAlertBarAction(action.payload.location.pathname);
        }),
        RxOp.catchError((err) => {
          return cashDrawerOpenError(action.payload.location.pathname, err);
        }),
      ),
    ),
  );
